import { __assign, __extends, __values } from "tslib";
import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
// Components.
import ProductListItem from '../ProductListItem';
import { EditLineDiscountModal } from '../EditLineDiscountModal';
import { EditLineDiscountMultipleModal } from '../EditLineDiscountMultipleModal';
// Utils.
import { cloneDeep, spread, union, uniq } from 'lodash';
import { humanReadableLineUnitPrices, totalLineAmount, roundAmount } from '../utils/priceHelper';
import { mapMoloItems } from '../models/MoloItem';
import { FaList, FaTh, FaPrint, FaPercent, FaPencilAlt } from 'react-icons/fa';
import { filterByValue } from '../utils/UtilHelper';
import { StyleBean } from '../models/Beans';
// const baseUrl = '/';// process.env.NODE_ENV === 'production' ? '/' : 'http://aws.molohub.com/';
var Details = /** @class */ (function (_super) {
    __extends(Details, _super);
    function Details() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showDeleteModal: false,
            modal: null,
            groupedOrderlines: [],
            productOverlayComponent: null,
            showOverlay: false,
            changes: {},
            isListView: true,
            showSizes: false,
            sizes: {},
            rrpMap: {},
            allSizes: {},
            showDiscount: false,
            showEditLineDiscountModal: false,
            showEditLineMultipleDiscountModal: false,
            searchTerm: '',
            showPrint: false,
            sortedByPriceDiffs: {},
        };
        _this.componentRef = React.createElement("div", null);
        _this.getGroupedPrices = function () {
            var e_1, _a;
            var sortedByPriceDiffs = {};
            for (var i in _this.props.allSizes) {
                sortedByPriceDiffs[i] = [];
                var allItems = _this.props.allSizes[i];
                var allPrices = uniq(allItems.map(function (item) { return item.price; }));
                var _loop_1 = function (value) {
                    var prices = allItems.filter(function (item) { return item.price === value; });
                    sortedByPriceDiffs[i].push({
                        currency: 'EUR',
                        price: value,
                        items: prices,
                    });
                };
                try {
                    for (var allPrices_1 = (e_1 = void 0, __values(allPrices)), allPrices_1_1 = allPrices_1.next(); !allPrices_1_1.done; allPrices_1_1 = allPrices_1.next()) {
                        var value = allPrices_1_1.value;
                        _loop_1(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (allPrices_1_1 && !allPrices_1_1.done && (_a = allPrices_1.return)) _a.call(allPrices_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.setState({ sortedByPriceDiffs: sortedByPriceDiffs });
            }
        };
        _this.openDeleteModal = function (line) {
            _this.setState({
                showDeleteModal: true
            }, function () {
                var modal = (
                // <ConfirmModal
                //         isShowing={this.state.showDeleteModal}
                //         hide={() => this.onHide()}
                //         content={(
                //             <div className="delete-order-modal">
                //                 <h2>Remove line</h2>
                //                 <p>Are you sure you want to remove this order item?</p>
                //                 <div className="delete-order-modal__footer">
                //                     <button className="btn ignore-clickoutside" onClick={() => this.onClickDelete(line)}>Yes!!</button>
                //                     <button className="btn ignore-clickoutside" onClick={() => this.onHide()}>Cancel</button>
                //                 </div>
                //             </div>
                //         )}
                // />
                React.createElement("div", null, "..."));
                _this.setState({ showDeleteModal: true, modal: modal });
            });
        };
        _this.onHide = function () {
            _this.setState({ showDeleteModal: false, modal: null });
        };
        _this.onHideProductOverlay = function () {
            _this.setState({ showOverlay: false });
        };
        _this.onClickDelete = function (line) {
            _this.props.onClickDelete(line);
            _this.onHide();
        };
        _this.handleOnProductClick = function (product, line) {
            if (line.quantityShipped > 0 || line.colorBlocked === true)
                return;
            if (_this.props.handleOnProductClick) {
                _this.props.handleOnProductClick(product);
            }
        };
        _this.renderTableHeader = function () {
            return (React.createElement("tr", null,
                React.createElement("td", { className: "details__image-col" }),
                React.createElement("td", { className: "details__product-col" }),
                React.createElement("td", null, "Sustainability"),
                React.createElement("td", null, "Quantity"),
                React.createElement("td", null, "Unit price"),
                _this.state.showDiscount &&
                    React.createElement("td", null,
                        React.createElement("span", null, "Discount"),
                        (_this.props.order.orderHeader.orderState === 0) ?
                            React.createElement("span", { onClick: function () { return _this.setState({ showEditLineMultipleDiscountModal: true }); }, className: "edit-pencil" },
                                React.createElement(FaPencilAlt, null))
                            : null),
                React.createElement("td", null, "RRP"),
                React.createElement("td", null, "Total"),
                _this.props.order.orderHeader.orderState === 0 &&
                    !_this.props.hideRemove &&
                    React.createElement("td", { className: "hide-on-mobile" })));
        };
        _this.renderTableHeaderPrint = function () {
            return (React.createElement("tr", null,
                React.createElement("td", { className: "details__image-col" }),
                React.createElement("td", { className: "details__product-col" }),
                React.createElement("td", null, "Sustainability"),
                React.createElement("td", null, "Quantity"),
                React.createElement("td", null, "Unit price"),
                React.createElement("td", null, "RRP"),
                _this.props.order && _this.props.order.orderHeader.orderLinediscount ?
                    React.createElement("td", null, "Discount") : null,
                React.createElement("td", null, "Total"),
                _this.props.order.orderHeader.orderState === 0 &&
                    React.createElement("td", { className: "hide-on-mobile" })));
        };
        _this.getSustainability = function (item) {
            if (item.gots !== '')
                return 'GOTS';
            if (item.oekotex !== '')
                return 'OEKOTEX';
            if (item.ocsno != '')
                return 'OCS 100';
            if (item.ocsblended != '')
                return 'OCS BLENDED';
            if (item.recycled)
                return 'RECYCLED';
            if (item.organic)
                return 'ORGANIC';
            if (item.ecovero)
                return 'ECOVERO';
            if (item.grsno != '')
                return 'GRS';
            return null;
        };
        _this.renderTableBody = function (orderLines, showSizes, withSubtotal) {
            return (React.createElement(React.Fragment, null,
                filterByValue(orderLines, _this.state.searchTerm)
                    .map(function (line, key) {
                    var imageUrl = _this.resolveLineImageUrl(line);
                    return (React.createElement(React.Fragment, { key: key },
                        React.createElement("tr", null,
                            React.createElement("td", { className: "details__image-cell", onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } },
                                React.createElement("img", { src: imageUrl, alt: line.description, className: "details__image" })),
                            React.createElement("td", { className: "details__product-cell", onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } },
                                React.createElement("div", { className: "details__info__data" },
                                    React.createElement("span", { className: "item-list__item__name__id" },
                                        line.masterId,
                                        " ",
                                        line.description),
                                    React.createElement("span", { className: "item-list__item__color" },
                                        line.colorCode,
                                        " ",
                                        line.colorName))),
                            React.createElement("td", { onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } }, _this.getSustainability(line)),
                            React.createElement("td", { onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } }, line.quantity),
                            React.createElement("td", { onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } }, humanReadableLineUnitPrices(line.masterId, line.colorCode, line.orderLines)),
                            _this.state.showDiscount &&
                                React.createElement("td", null,
                                    line.linediscountpct > 0 &&
                                        React.createElement(React.Fragment, null,
                                            roundAmount(_this.totalLineDiscountAmount(line.masterId, line.colorCode)),
                                            " ( ",
                                            line.linediscountpct,
                                            "% )"),
                                    (_this.props.order.orderHeader.orderState === 0) ?
                                        React.createElement("span", { className: "edit-pencil", onClick: function () { return _this.setState({ showEditLineDiscountModal: true, selectedOrderline: line }); } },
                                            React.createElement(FaPencilAlt, null))
                                        : null),
                            React.createElement("td", { onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); } },
                                React.createElement("div", null, _this.props.rrpMap[line.masterId + line.colorCode] ?
                                    _this.props.rrpMap[line.masterId + line.colorCode].map(function (item, key) {
                                        return (React.createElement(React.Fragment, { key: key },
                                            roundAmount(item),
                                            key + 1 !== _this.props.rrpMap[line.masterId + line.colorCode].length && React.createElement("span", null, " / ")));
                                    })
                                    : React.createElement("span", { style: { visibility: 'hidden' } }, "..."))),
                            React.createElement("td", null,
                                roundAmount(totalLineAmount(line.masterId, line.colorCode, line.orderLines)),
                                " "),
                            _this.props.order.orderHeader.orderState === 0 &&
                                !_this.props.hideRemove &&
                                React.createElement("td", { className: "hide-on-mobile center" },
                                    line.colorBlocked !== true && line.quantityShipped < 1 && React.createElement("button", { onClick: function () { return _this.props.onClickRemove && _this.props.onClickRemove(line); }, className: "details__remove" }, "Remove"),
                                    !line.colorBlocked && line.quantityShipped > 0 ?
                                        React.createElement("div", { className: "item-blocked relative" }, "Shipped") : null,
                                    line.colorBlocked ?
                                        React.createElement("span", { className: "item-blocked relative" }, "Cancelled") : null)),
                        showSizes &&
                            React.createElement(React.Fragment, { key: line.seasonCode + '/' + line.masterId + '/' + line.colorCode },
                                React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 8 },
                                        React.createElement("div", { className: "details__sizes" }, _this.props.allSizes[line.masterId + line.colorCode] &&
                                            _this.props.allSizes[line.masterId + line.colorCode].map(function (size, index) {
                                                return (React.createElement("div", { className: "details__size", key: 'allSizes' + line.masterId + line.colorCode + index },
                                                    React.createElement("div", { className: "details__size__name" }, size.sizename),
                                                    React.createElement("div", { className: "details__size__quantity" }, size.quantity)));
                                            })))))));
                }),
                _this.state.showDeleteModal && _this.state.modal));
        };
        _this.onChangeHandler = function () {
            _this.setState({ isListView: !_this.state.isListView });
        };
        _this.getStyleBean = function (line) {
            // Dirty but useful fallback.
            if (!_this.props.groupedMoloItems[line.masterId + line.colorCode]) {
                return StyleBean.build(line, 'orderLine');
            }
            var bean = StyleBean.build(mapMoloItems(_this.props.groupedMoloItems[line.masterId + line.colorCode])[0], 'moloItem');
            bean.currencyCode = _this.props.order.orderHeader.currencyCode || 'EUR';
            if (line.deliveryWindow) {
                bean.deliveryWindow = line.deliveryWindow;
            }
            if (line.collectionName) {
                bean.collectionName = line.collectionName;
            }
            return bean;
        };
        _this.renderGrid = function () {
            return (React.createElement("ul", { className: "pl" }, _this.props.groupedOrderlines.map(function (line, key) {
                return (React.createElement(React.Fragment, { key: key }, React.createElement("li", { onClick: function () { return _this.handleOnProductClick(_this.getStyleBean(line), line); }, className: "pl-item__wrapper" },
                    React.createElement(ProductListItem, { product: _this.getStyleBean(line), lazyLoadMoloMaster: true, quantityOveride: line.quantity, baseUrl: _this.props.baseUrl, imageUrlForProduct: _this.props.imageUrlForProduct }),
                    _this.state.showSizes &&
                        React.createElement("div", { className: "details__sizes__overlay" },
                            React.createElement("div", { className: "details__sizes" }, _this.props.allSizes[line.masterId + line.colorCode] &&
                                _this.props.allSizes[line.masterId + line.colorCode].map(function (size, index) {
                                    return (React.createElement("div", { className: "details__size", key: 'allSizes' + line.masterId + line.colorCode + index },
                                        React.createElement("div", { className: "details__size__name" }, size.sizename),
                                        React.createElement("div", { className: "details__size__quantity" }, size.quantity)));
                                }))))));
            })));
        };
        _this.groupBy = function (key) { return function (array) {
            return array.reduce(function (objectsByKeyValue, obj) {
                var value = obj[key];
                objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                return objectsByKeyValue;
            }, {});
        }; };
        _this.totalLineDiscountAmount = function (masterId, colorCode) {
            var totalDiscountAmount = 0;
            var line = _this.props.order.orderLines.filter(function (item) {
                return item.masterId === masterId && item.colorCode === colorCode;
            });
            for (var i in line) {
                totalDiscountAmount = totalDiscountAmount + line[i].linediscountamount;
            }
            return totalDiscountAmount;
        };
        _this.renderPrint = function () {
            if (!_this.props.deliveryWindows.length)
                return null;
            var order = _this.props.order.orderHeader;
            // Group every thing by delivery windows.
            var groupByDeliveryCode = _this.groupBy(['deliveryCode']);
            var groupedByDeliveryCode = groupByDeliveryCode(_this.props.orderLines);
            var sortedWithGroup = {};
            // And then inside every delivery window, group by product group.
            for (var key in groupedByDeliveryCode) {
                var groupByProductGroup = _this.groupBy(['productGroup']);
                var grouped = groupByProductGroup(groupedByDeliveryCode[key]);
                sortedWithGroup[key] = grouped;
            }
            var sorted = _this.props.deliveryWindows.sort(function (a, b) {
                return new Date(a.shippingDate).getTime() - new Date(b.shippingDate).getTime();
            });
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { ref: function (el) { return (_this.componentRef = el); }, className: "print-view" },
                    React.createElement("div", { className: "print-header" },
                        React.createElement("span", null, order.sellToCustomerName),
                        React.createElement("span", null,
                            " | SB",
                            order.appOrderId),
                        React.createElement("span", null,
                            " | ",
                            order.orderType),
                        order.navImportRef &&
                            React.createElement("span", null,
                                "| ",
                                order.navImportRef),
                        order.salespersonNote &&
                            React.createElement("span", null,
                                "| ",
                                order.salespersonNote),
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "grand-total print-fragment__subtotal'" },
                                React.createElement("h2", { style: { textAlign: 'right', marginRight: '25px' } }, "Grand Total"),
                                React.createElement("div", { className: 'print-fragment__subtotal' },
                                    React.createElement("div", { className: "--total --right" }),
                                    React.createElement("div", { className: "--right" },
                                        "Quantity: ",
                                        _this.props.order.orderTotals.noOfItems),
                                    React.createElement("div", { className: "--right" },
                                        "Total: ",
                                        roundAmount(_this.props.order.orderTotals.amount)))))),
                    sorted && sorted.length && sorted.map(function (deliveryWindow, key) {
                        var deliveryGroup = sortedWithGroup[deliveryWindow.deliveryCode];
                        if (!deliveryGroup)
                            return null;
                        var values = Object.values(deliveryGroup);
                        var isLast = (sorted.length - 1) === key;
                        var allTheValues = spread(union)(values);
                        var totalQuantity = allTheValues.map(function (value) { return value.quantity; }).reduce(function (a, b) { return a + b; });
                        var total = allTheValues.map(function (value) { return value.amount; }).reduce(function (a, b) { return a + b; });
                        var shipmentDate = deliveryGroup[Object.keys(deliveryGroup)[0]][0].deliveryshiptmentdate;
                        return (React.createElement("div", { key: key, className: "print-fragment" },
                            React.createElement("div", { className: "print-fragment__header" },
                                React.createElement("span", null, deliveryWindow.deliveryCode === 'specdate' ? 'Shipping date' : deliveryWindow.deliveryCode),
                                React.createElement("span", { className: "--date" }, new Date(shipmentDate).toLocaleDateString())),
                            Object.keys(deliveryGroup).map(function (key) {
                                var items = _this.groupSimilarColors(cloneDeep(deliveryGroup[key]));
                                return (React.createElement(React.Fragment, { key: key },
                                    React.createElement("h2", { className: 'category-name sticky__wrapper' },
                                        React.createElement("span", { className: "category-name__text" }, key)),
                                    React.createElement("table", { className: "details striped-table" },
                                        React.createElement("thead", null, _this.renderTableHeader()),
                                        React.createElement("tbody", null, _this.renderTableBody(items, true, true)))));
                            }),
                            React.createElement("div", { className: 'print-fragment__subtotal' },
                                React.createElement("div", { className: "--total" }, "Subtotal"),
                                React.createElement("div", { className: "--right" },
                                    "Quantity: ",
                                    totalQuantity),
                                React.createElement("div", { className: "--right" },
                                    "Total: ",
                                    roundAmount(total)))));
                    }))));
        };
        return _this;
    }
    Details.prototype.componentDidMount = function () {
        if (this.props.allSizes && Object.keys(this.props.allSizes).length) {
            this.getGroupedPrices();
        }
    };
    Details.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.groupedMoloItems !== this.props.groupedMoloItems ||
            prevProps.groupedOrderlines !== this.props.groupedOrderlines) {
            this.getGroupedPrices();
        }
        if (this.props.allSizes && Object.keys(this.props.allSizes).length !== Object.keys(prevProps.allSizes).length) {
            this.getGroupedPrices();
        }
    };
    Details.prototype.groupSimilarColors = function (orderLines) {
        var grouped = {};
        var sizes = {};
        for (var i in orderLines) {
            var orderline = orderLines[i];
            var masterid = orderline.masterId;
            var colorcode = orderline.colorCode;
            if (grouped[masterid + colorcode]) {
                var q = +grouped[masterid + colorcode].quantity + +orderline.quantity;
                grouped[masterid + colorcode].quantity = q;
                grouped[masterid + colorcode]['orderLines'].push(__assign({}, orderline));
            }
            else {
                grouped[masterid + colorcode] = orderline;
                grouped[masterid + colorcode]['orderLines'] = [__assign({}, orderline)];
            }
            if (!sizes[masterid + colorcode]) {
                sizes[masterid + colorcode] = [];
            }
            sizes[masterid + colorcode].push({ sizename: orderline.sizeName, quantity: orderline.quantity, price: orderline.whp });
        }
        // this.setState({ sizes })
        var g = [];
        for (var key in grouped) {
            var line = grouped[key];
            var q = 0;
            for (var delta in line['orderLines']) {
                q = q + line['orderLines'][delta].quantity;
            }
            line.quantity = q;
            g.push(line);
        }
        var sorted = g.sort(function (a, b) { return (a.masterId > b.masterId) ? 1 : -1; });
        return sorted;
    };
    Details.prototype.resolveLineImageUrl = function (line) {
        if (this.props.getLineImageUrl) {
            return this.props.getLineImageUrl(line);
        }
        return (this.props.baseUrl +
            'productimage/' +
            line.seasonCode +
            '/' +
            line.masterId +
            '/' +
            line.colorCode +
            '/small');
    };
    Details.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, { key: this.props.order.orderHeader.appOrderId },
            React.createElement("div", { className: "dashboard-details" },
                React.createElement("div", { className: "dashboard-details__header" },
                    React.createElement("div", { onClick: function () { return _this.setState({ isListView: true }); }, className: "dashboard-details__header__toggler" + (this.state.isListView ? ' active' : '') },
                        React.createElement(FaList, null)),
                    React.createElement("div", { onClick: function () { return _this.setState({ isListView: false }); }, className: "dashboard-details__header__toggler" + (!this.state.isListView ? ' active' : '') },
                        React.createElement(FaTh, null)),
                    React.createElement("div", { className: "dashboard-details__header__item dashboard-details__header__show-sizes" },
                        React.createElement("div", { className: "pretty p-default form-group" },
                            React.createElement("input", { className: "a-form-control a-form-control--checkbox", checked: this.state.showSizes, onChange: function () { _this.setState({ showSizes: !_this.state.showSizes }); }, type: "checkbox" }),
                            React.createElement("div", { className: "state" },
                                React.createElement("label", null, "Show sizes")))),
                    React.createElement("div", { className: "dashboard-details__header__item dashboard-details__header__show-sizes" },
                        React.createElement("div", { className: "pretty p-default form-group" },
                            React.createElement("input", { className: "a-form-control a-form-control--checkbox", checked: this.state.showDiscount, onChange: function () { return _this.setState({ showDiscount: !_this.state.showDiscount }); }, type: "checkbox" }),
                            React.createElement("div", { className: "state" },
                                React.createElement("label", null,
                                    React.createElement("span", null, "Show discount  "),
                                    React.createElement("span", { style: { fontSize: '9px' } },
                                        React.createElement(FaPercent, null)))))),
                    (Object.keys(this.props.rrpMap).length ||
                        (this.props.order && this.props.order.orderHeader.navImportRef && this.props.order.orderHeader.orderState === 1)) ?
                        React.createElement("div", { className: "dashboard-details__header__item --print clickable" },
                            React.createElement(ReactToPrint, { trigger: function () { return React.createElement("div", { className: "dashboard-details__header__item --print" },
                                    React.createElement(FaPrint, null),
                                    React.createElement("span", null, "Print basket")); }, content: function () { return _this.componentRef; } })) : null,
                    React.createElement("div", { className: "dashboard-details__header__item dashboard-search-wrapper" },
                        React.createElement("input", { type: "text", className: "--dashboard-search", placeholder: "Search in basket", onChange: function (event) {
                                var value = event.target.value;
                                _this.setState({ searchTerm: value });
                            } }))),
                this.state.isListView &&
                    React.createElement("table", { className: "details striped-table" },
                        React.createElement("thead", null, this.renderTableHeader()),
                        React.createElement("tbody", null, this.renderTableBody(this.props.groupedOrderlines, this.state.showSizes))),
                !this.state.isListView &&
                    this.renderGrid(),
                this.renderPrint(),
                this.state.showEditLineDiscountModal &&
                    React.createElement(EditLineDiscountModal, { order: this.props.order, orderId: this.props.order.orderHeader.appOrderId, line: this.state.selectedOrderline, show: this.state.showEditLineDiscountModal, shouldHide: function () { return _this.setState({ showEditLineDiscountModal: false }); }, onChangeDiscount: this.props.onChangeDiscount }),
                this.state.showEditLineMultipleDiscountModal &&
                    React.createElement(EditLineDiscountMultipleModal, { show: this.state.showEditLineMultipleDiscountModal, shouldHide: function () { return _this.setState({ showEditLineMultipleDiscountModal: false }); }, onChangeDiscountMultiple: this.props.onChangeDiscountMultiple }))));
    };
    return Details;
}(Component));
export { Details };
//# sourceMappingURL=Details.js.map